export default __webpack_public_path__ + "media/strasse.b9a2c0dc.jpg";